import classNames from 'classnames';
import React from 'react';

import { PurposeMapCardDiagramProps } from '../charts/SoulMatrix/types';

import styles from './PurposeMap.module.scss';

function PurposeMapCardDiagram({ top, bottom, right }: PurposeMapCardDiagramProps) {
  return (
    <>
      <div className={styles.cardCalculation__label}>
        <span>{top.label}</span>
        <span>{bottom.label}</span>
      </div>
      <div>
        <svg width="85" height="65" viewBox="0 -6 103 80" fill="none">
          <g>
            <g id={top.id} className={`group ${classNames({ [styles.active]: top.isHighLighted })}`}>
              <circle cx="15" cy="15" r="14" stroke="#FFF4E6" />
              <text id="top" className="number" x="15" y="16" textAnchor="middle" dominantBaseline="middle">
                {top.value}
              </text>
            </g>
            <g id={right.id} className={`group ${classNames({ [styles.active]: right.isHighLighted })}`}>
              <circle cx="86" cy="36" r="14" stroke="#FFF4E6" />
              <text id="right" className="number" x="86" y="37" textAnchor="middle" dominantBaseline="middle">
                {right.value}
              </text>
            </g>
            <g id={bottom.id} className={`group ${classNames({ [styles.active]: bottom.isHighLighted })}`}>
              <circle cx="15" cy="58" r="14" stroke="#FFF4E6" />
              <text id="bottom" className="number" x="15" y="59" textAnchor="middle" dominantBaseline="middle">
                {bottom.value}
              </text>
            </g>
            <path
              id="Union"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M34.3334 16H50.3334V36V37V57H34.3334V58H50.3334V58.0116H51.3334V58V57V37H67.3334V36H51.3334V16V15H50.3334H34.3334V16Z"
              fill="#FFF4E6"
            />
          </g>
        </svg>
      </div>
    </>
  );
}

export default React.memo(PurposeMapCardDiagram);
